export default __webpack_public_path__ + "static/media/ic_reports_b.7e7106d0.svg";